import { render } from "./MiniMenu.vue?vue&type=template&id=1f8b936e&scoped=true"
import script from "./MiniMenu.vue?vue&type=script&lang=js"
export * from "./MiniMenu.vue?vue&type=script&lang=js"

import "./MiniMenu.vue?vue&type=style&index=0&id=1f8b936e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f8b936e"]])

export default __exports__